import { Numeric6Icon } from './Numeric6Icon';

/**
 * author: GreenTurtwig
 * id 8B73A4D3-4AC9-448B-8C60-497EC2167898
 * name numeric-6
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-6.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericSixIcon = Numeric6Icon;
export default NumericSixIcon